/**
 * GiveX PDP Input Manager
 * Manages placeholder text and label content for GiveX gift card inputs
 * Loads customizable values from Shopify section settings
 */

class GiveXInputManager {
  /**
   * Creates a new GiveXInputManager instance
   * Initializes configuration for input placeholders and label text
   * @constructor
   */
  constructor() {
    this.inputConfigs = [
      //placeholders
      { selector: '[data-givex-sender-email]', placeholder: '', dataKey: 'givexSenderPlaceholder' },
      { selector: '[data-givex-recipient-email]', placeholder: '', dataKey: 'givexRecipientPlaceholder' },
      { selector: '[data-givex-sender-name]', placeholder: '', dataKey: 'givexSenderNamePlaceholder' },
      { selector: '[data-givex-recipient-name]', placeholder: '', dataKey: 'givexRecipientNamePlaceholder' },
      { selector: '[data-givex-message]', placeholder: '', dataKey: 'givexGiftCardMessagePlaceholder' },

      //Input labels
      { selector: 'label[for=givex-sender-email]', label: 'Enter your email ID', required:true, dataKey: 'givexSenderLabel' },
      { selector: 'label[for=givex-recipient-email]', label: 'Enter recipient’s email ID', required:false, dataKey: 'givexRecipientLabel' },
      { selector: 'label[for=givex-sender-name]', label: 'Enter sender’s name', required:true, dataKey: 'givexSenderNameLabel' },
      { selector: 'label[for=givex-recipient-name]', label: 'Enter recipient’s name', required:true, dataKey: 'givexRecipientNameLabel' },
      { selector: 'label[for=givex-gift-card-message]', label: '', required:false, dataKey: 'givexGiftCardMessageLabel' }

    ];
    this.init();
  }

  /**
   * Initializes the input manager
   * Loads settings from section data attributes and updates existing inputs and labels
   * Only runs if GiveX form component is present on the page
   */
  init() {
    // Check if GiveX form exists on the page before proceeding
    const productInfo = document.querySelector('product-info[data-product-info]');
    const givexForm = productInfo ? productInfo.querySelector('givex-form.product-main__product-form-givex') : null;
    
    if (!givexForm) {
      console.log('GiveX form not found, skipping placeholder manager initialization');
      return;
    }

    // Load custom placeholder text from section settings
    this.loadPlaceholdersFromSettings();
    
    // Update existing inputs immediately
    this.updateExistingInputs();

  }
  
  /**
   * Loads custom placeholder and label values from product-info data attributes
   * Updates inputConfigs with values from Shopify section settings
   * @private
   */
  loadPlaceholdersFromSettings() {
    const productInfo = document.querySelector('product-info[data-product-info]');
    if (!productInfo) return;
    
    this.inputConfigs.forEach(config => {
      const dataValue = productInfo.dataset[config.dataKey];
      if ('label' in config) {
        config.label = dataValue;
      } else if ('placeholder' in config) {
        config.placeholder = dataValue;
      }
    });
  }

  /**
   * Updates all existing GiveX inputs and labels in the DOM with configured values
   * @private
   */
  updateExistingInputs() {
    this.inputConfigs.forEach(config => {
      const element = document.querySelector(config.selector);
      if ('label' in config) {
        this.updateLabel(element, config.label, config.required);
      } else if ('placeholder' in config) {
        this.updateInputPlaceholder(element, config.placeholder);
      }
    });
  }

  /**
   * Updates a single input element's placeholder attribute
   * @param {HTMLInputElement|HTMLTextAreaElement} input - The input or textarea element to update
   * @param {string} placeholder - The placeholder text to set
   */
  updateInputPlaceholder(input, placeholder) {
    if (input && 'placeholder' in input && input.placeholder !== placeholder) {
      input.placeholder = placeholder;
    }
  }

  /**
   * Updates a label element's text content
   * Prepends an asterisk (*) for required fields
   * @param {HTMLElement} label - The label element to update
   * @param {string} text - The text to set
   * @param {boolean} required - Whether the field is required (adds asterisk prefix)
   * @private
   */
  updateLabel(label, text, required) {
    if (!label) return;
    const labelText = required ? '*' + text : text;
    if (label.innerHTML !== labelText) {
      label.innerHTML = labelText;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new GiveXInputManager();
  });
} else {
  new GiveXInputManager();
}
